import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormArray,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AddInstituteService } from '../../../../services/super-admin/add-institute.service';
import {
  Undergraduaterequest,
  Undergraduateresponse,
} from '../../../../models/Institutedetails/Undergraduaterequest';
import { apiResponse } from '../../../../models/apiResponse';
import { scrollToFirstInvalidControl } from '../../../../direct-apply/shared/validators/form-validation.utils';

@Component({
  selector: 'app-undergraduate',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    InputTextareaModule,
    InputNumberModule,
    AccordionModule,
    CalendarModule,
    InputSwitchModule,
  ],
  templateUrl: './undergraduate.component.html',
  styleUrls: ['./undergraduate.component.scss'],
})
export class UndergraduateComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() instituteId: string | null = null;
  @Input() isEditMode: boolean = false;
  @Output() onSaveSuccess = new EventEmitter<any>();
  @Output() onSaveError = new EventEmitter<any>();
  private undergraduateId: number = 0;
  private detailsLoaded = false;
  currency = [
    { label: 'USD', value: 0 },
    { label: 'INR', value: 1 },
    { label: 'EUR', value: 2 },
    { label: 'GBP', value: 3 },
  ];
  constructor(
    private fb: FormBuilder,
    private addInstituteService: AddInstituteService,
  ) {}

  ngOnChanges(changes: import('@angular/core').SimpleChanges) {
    if (
      changes['instituteId'] &&
      this.instituteId &&
      this.isEditMode &&
      !this.detailsLoaded
    ) {
      this.detailsLoaded = true;
      this.loadUndergraduateDetails();
    }
  }

  ngOnInit() {
    if (this.form) {
      this.form.addControl('applicationFees', this.fb.control(''));
      this.form.addControl('currency', this.fb.control(0));
      this.form.addControl('totalApplicants', this.fb.control(null));

      this.form.addControl('earlyActionDeadline', this.fb.control(''));
      this.form.addControl('earlyDecision1Deadline', this.fb.control(''));
      this.form.addControl('earlyDecision2Deadline', this.fb.control(''));
      this.form.addControl('regularDecisionDeadline', this.fb.control(''));
      this.form.addControl('medicalApplicationsDeadline', this.fb.control(''));

      this.form.addControl('satReadingWriting90', this.fb.control(''));
      this.form.addControl('satMath90', this.fb.control(''));
      this.form.addControl('satOverallMidpoint', this.fb.control(''));
      this.form.addControl('actComposite90', this.fb.control(''));
      this.form.addControl('actEnglish90', this.fb.control(''));
      this.form.addControl('actMathMidpoint', this.fb.control(''));

      this.form.addControl('percentSATSubmitting', this.fb.control(''));
      this.form.addControl('percentACTSubmitting', this.fb.control(''));

      this.form.addControl('secondarySchoolGPAMode', this.fb.control(''));
      this.form.addControl('secondarySchoolRankMode', this.fb.control(''));
      this.form.addControl('secondarySchoolRecordMode', this.fb.control(''));
      this.form.addControl('collegePrepProgramMode', this.fb.control(''));
      this.form.addControl('recommendations', this.fb.control(''));
      this.form.addControl('essayPersonalStatement', this.fb.control(''));
      this.form.addControl(
        'admissionTestScoreRequirements',
        this.fb.control(''),
      );
      this.form.addControl('englishLanguageRequirement', this.fb.control(''));
      this.form.addControl(
        'formalDemonstrationCompetences',
        this.fb.control(''),
      );
      this.form.addControl('workExperienceRequired', this.fb.control(''));
      this.form.addControl('legacyStatus', this.fb.control(''));

      this.form.addControl('avgCostOfAttendance', this.fb.control(''));
      this.form.addControl('avgTuitionFees', this.fb.control(''));
      this.form.addControl('estimatedBooksSupplies', this.fb.control(''));
      this.form.addControl('onCampusRoomBoard', this.fb.control(''));
      this.form.addControl('onCampusOtherExpenses', this.fb.control(''));
      this.form.addControl('offCampusRoomBoard', this.fb.control(''));
      this.form.addControl('offCampusOtherExpenses', this.fb.control(''));
      this.form.addControl('housingCapacity', this.fb.control(''));
      this.form.addControl('combinedFoodHousingCharge', this.fb.control(''));
      this.form.addControl('medianFamilyIncome', this.fb.control(''));
      this.form.addControl('avgGrantAmount', this.fb.control(''));

      this.form.addControl('percentStudentsAwardedGrant', this.fb.control(''));
      this.form.addControl('findScholarshipsLink', this.fb.control(''));

      this.form.addControl('fullTimeEnrollment', this.fb.control(''));
      this.form.addControl('partTimeEnrollment', this.fb.control(''));
      this.form.addControl('totalEnrollment', this.fb.control(''));
      this.form.addControl('internationalStudents', this.fb.control(''));
      this.form.addControl(
        'fullTimeUndergraduateMaleEnrollment',
        this.fb.control(''),
      );
      this.form.addControl(
        'fullTimeUndergraduateFemaleEnrollment',
        this.fb.control(''),
      );
      this.form.addControl(
        'fullTimeUnderGraduateIndianStudents',
        this.fb.control(''),
      );

      this.form.addControl('malePercentage', this.fb.control(''));
      this.form.addControl('femalePercentage', this.fb.control(''));
      this.form.addControl('whitePercentage', this.fb.control(''));
      this.form.addControl('blackPercentage', this.fb.control(''));
      this.form.addControl('hispanicPercentage', this.fb.control(''));
      this.form.addControl('asianPercentage', this.fb.control(''));
      this.form.addControl('americanIndianPercentage', this.fb.control(''));
      this.form.addControl('nativeHawaiianPercentage', this.fb.control(''));
      this.form.addControl('twoOrMoreRacesPercentage', this.fb.control(''));
      this.form.addControl('raceUnknownPercentage', this.fb.control(''));

      this.form.addControl('studentFacultyRatio', this.fb.control(''));
      this.form.addControl(
        'fullTimeUSNonResidentFacultyShare',
        this.fb.control(''),
      );
      this.form.addControl('fullTimeFacultyProportion', this.fb.control(''));
      this.form.addControl('numCoursesOffered', this.fb.control(''));
      this.form.addControl('totalDepartments', this.fb.control(''));
      this.form.addControl('faculty', this.fb.control(''));

      this.form.addControl('acceptanceRate', this.fb.control(''));
      this.form.addControl('graduationRate', this.fb.control(''));
      this.form.addControl(
        'percentEarningAboveHighSchool11Years',
        this.fb.control(''),
      );
      this.form.addControl(
        'internationalStudentsGraduationRate',
        this.fb.control(''),
      );

      this.form.addControl('medianEarnings1Year', this.fb.control(''));
      this.form.addControl('medianEarnings5Years', this.fb.control(''));
      this.form.addControl('foodAndOtherExpenses', this.fb.control(''));

      this.form.addControl('popularEmployers', this.fb.control(''));
      this.form.addControl('additionalNotes', this.fb.control(''));
      this.form.addControl('uk', this.fb.control(''));
      this.form.addControl('eu', this.fb.control(''));
      this.form.addControl('postGraduate', this.fb.control(''));
      this.form.addControl('underGraduate', this.fb.control(''));

      if (this.isEditMode && this.instituteId && !this.detailsLoaded) {
        this.detailsLoaded = true;
        this.loadUndergraduateDetails();
      }
    }
  }
  private parseDateSafe(date: any): Date | null {
    if (!date) return null;
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d;
  }
  private loadUndergraduateDetails() {
    if (this.instituteId) {
      this.addInstituteService
        .getUndergraduateDetails(this.instituteId)
        .subscribe({
          next: (response: apiResponse<Undergraduateresponse>) => {
            const data = response.result || (response as any);
            if (data) {
              this.undergraduateId = data.id;
              this.form.patchValue({
                applicationFees: data.applicationFees,
                currency: data.currency,
                totalApplicants: data.totalApplicants,
                earlyActionDeadline: this.parseDateSafe(
                  data.applicationDeadlineEarlyAction,
                ),
                earlyDecision1Deadline: this.parseDateSafe(
                  data.applicationDeadlineEarlyDecisionOne,
                ),
                earlyDecision2Deadline: this.parseDateSafe(
                  data.applicationDeadlineEarlyDecisionTwo,
                ),
                regularDecisionDeadline: this.parseDateSafe(
                  data.applicationDeadlineRegularDecision,
                ),
                medicalApplicationsDeadline: this.parseDateSafe(
                  data.medicalApplicationsDeadline,
                ),
                // earlyActionDeadline: data.applicationDeadlineEarlyAction ? new Date(data.applicationDeadlineEarlyAction) : null,
                // earlyDecision1Deadline: data.applicationDeadlineEarlyDecisionOne ? new Date(data.applicationDeadlineEarlyDecisionOne) : null,
                // earlyDecision2Deadline: data.applicationDeadlineEarlyDecisionTwo ? new Date(data.applicationDeadlineEarlyDecisionTwo) : null,
                // regularDecisionDeadline: data.applicationDeadlineRegularDecision ? new Date(data.applicationDeadlineRegularDecision) : null,
                // medicalApplicationsDeadline: data.medicalApplicationsDeadline ? new Date(data.medicalApplicationsDeadline) : null,
                satReadingWriting90:
                  data.fiftythSATEvidenceBasedReadingAndWritingPercentileScore,
                satMath90: data.fiftythSATMathPercentileScore,
                satOverallMidpoint: data.midpointOverallSATScore,
                actComposite90: data.fiftythACTCompositePercentileScore,
                actEnglish90: data.fiftythACTEnglishPercentileScore,
                actMathMidpoint: data.midpointOfACTMathScore,
                percentSATSubmitting:
                  data.percentageOfFirstTimeDegreeOrCertificateSeekingStudentsSubmittingSATScore,
                percentACTSubmitting:
                  data.percentageOfFirstTimeDegreeOrCertificateSeekingStudentsSubmittingACTScore,
                secondarySchoolGPAMode: data.secondarySchoolGPARequirement,
                secondarySchoolRankMode: data.secondarySchoolRankRequirement,
                secondarySchoolRecordMode:
                  data.secondarySchoolRecordRequirement,
                collegePrepProgramMode:
                  data.completionOfCollegePreparatoryProgramRequirement,
                recommendations: data.recommendations,
                essayPersonalStatement:
                  data.personalStatementOrEssayRequirement,
                admissionTestScoreRequirements:
                  data.admissionTestScoresRequirements,
                englishLanguageRequirement: data.englishLanguageRequirement,
                formalDemonstrationCompetences:
                  data.formalDemonstrationOfCompetenciesRequirement,
                workExperienceRequired: data.workExperienceRequirement,
                legacyStatus: data.legacyStatusRequirement,
                avgCostOfAttendance: data.averageCostOfAttendance,
                avgTuitionFees: data.averageTutionFees,
                estimatedBooksSupplies: data.estimatedBooksAndSupplies,
                onCampusRoomBoard: data.onCampusRoomAndBoard,
                onCampusOtherExpenses: data.onCampusOtherExpenses,
                offCampusRoomBoard: data.offCampusRoomAndBoard,
                offCampusOtherExpenses: data.offCampusOtherExpenses,
                housingCapacity: data.housingCapacity,
                combinedFoodHousingCharge: data.combinedFoodAndHousingCharge,
                medianFamilyIncome: data.medianFamilyIncome,
                avgGrantAmount:
                  data.averageFirstTimeFullTimeUndergradsAwardedInstitutionalGrant,
                percentStudentsAwardedGrant:
                  data.percentFirstTimeFullTimeUndergradsAwardedInstitutionalGrant,
                findScholarshipsLink:
                  data.findScholarships && data.findScholarships.length > 0
                    ? data.findScholarships[0]
                    : '',
                fullTimeEnrollment: data.fullTimeEnrollment,
                partTimeEnrollment: data.partTimeStudentEnrollment,
                totalEnrollment: data.totalEnrollmentInInstitution,
                internationalStudents: data.internationStudentsEnrollment,
                fullTimeUndergraduateMaleEnrollment:
                  data.fullTimeUndergraduateMaleEnrollment,
                fullTimeUndergraduateFemaleEnrollment:
                  data.fullTimeUndergraduateFemaleEnrollment,
                fullTimeUnderGraduateIndianStudents:
                  data.fullTimeUnderGraduateIndianStudents,
                malePercentage: data.maleEnrollment,
                femalePercentage: data.femaleEnrollment,
                whitePercentage: data.white,
                blackPercentage: data.black,
                hispanicPercentage: data.hispanic,
                asianPercentage: data.asian,
                americanIndianPercentage: data.americanIndianOrAlaskaNative,
                nativeHawaiianPercentage:
                  data.nativeHawaiianOrOtherPacificIslander,
                twoOrMoreRacesPercentage: data.twoOrMoreRaces,
                raceUnknownPercentage: data.raceOrEthnicityUnknown,
                studentFacultyRatio: data.studentFacultyRatio,
                fullTimeUSNonResidentFacultyShare:
                  data.fullTimeUSNonResidentFacultyShare,
                fullTimeFacultyProportion: data.fullTimeFacultyProportion,
                numCoursesOffered: data.numberOfCoursesOffered,
                totalDepartments: data.totalDepartments,
                faculty: data.faculty,
                acceptanceRate: data.acceptanceRate,
                graduationRate: data.totalCohortGraduationRate,
                percentEarningAboveHighSchool11Years:
                  data.percentEarningAboveHighSchool11Years,
                internationalStudentsGraduationRate:
                  data.internationalStudentsGraduationRate,
                medianEarnings1Year:
                  data.medianEarningsOfGraduatesWorkingPostOneYearCompletion,
                medianEarnings5Years:
                  data.medianEarningsOfGraduatesWorkingPostFiveYearCompletion,
                foodAndOtherExpenses: data.foodAndOtherExpenses,
                popularEmployers: data.popularEmployers,
                additionalNotes: data.others,
                uk: data.uk || '',
                eu: data.eu || '',
                postGraduate: data.postGraduate || '',
                underGraduate: data.underGraduate || '',
              });
            }
          },
          error: (err: any) => this.onSaveError.emit(err),
        });
    }
  }

  private formatDate(date: any): string {
    if (!date) return '';
    try {
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch {
      return '';
    }
  }
  private toIsoStringSafe(date: any): string {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    return d.toISOString();
  }
  save() {
    if (this.form.valid) {
      if (!this.instituteId) {
        this.onSaveError.emit({
          message:
            'Institute ID is missing. Please save Basic Information first.',
        });
        return;
      }
      const formValue = this.form.value;
      const request: Undergraduaterequest = {
        id: this.undergraduateId > 0 ? this.undergraduateId : undefined,
        instituteId: String(this.instituteId || ''),
        applicationFees: formValue.applicationFees || '',
        applicationDeadlineEarlyAction: this.toIsoStringSafe(
          formValue.earlyActionDeadline,
        ),
        applicationDeadlineEarlyDecisionOne: this.toIsoStringSafe(
          formValue.earlyDecision1Deadline,
        ),
        applicationDeadlineEarlyDecisionTwo: this.toIsoStringSafe(
          formValue.earlyDecision2Deadline,
        ),
        applicationDeadlineRegularDecision: this.toIsoStringSafe(
          formValue.regularDecisionDeadline,
        ),

        // applicationDeadlineEarlyAction: formValue.earlyActionDeadline ? new Date(formValue.earlyActionDeadline).toISOString() : '',
        // applicationDeadlineEarlyDecisionOne: formValue.earlyDecision1Deadline ? new Date(formValue.earlyDecision1Deadline).toISOString() : '',
        // applicationDeadlineEarlyDecisionTwo: formValue.earlyDecision2Deadline ? new Date(formValue.earlyDecision2Deadline).toISOString() : '',
        // applicationDeadlineRegularDecision: formValue.regularDecisionDeadline ? new Date(formValue.regularDecisionDeadline).toISOString() : '',
        currency: Number(formValue.currency ?? 0),
        totalApplicants: parseInt(formValue.totalApplicants) || 0,
        fiftythSATEvidenceBasedReadingAndWritingPercentileScore:
          parseInt(formValue.satReadingWriting90) || 0,
        fiftythSATMathPercentileScore: parseInt(formValue.satMath90) || 0,
        midpointOverallSATScore: parseInt(formValue.satOverallMidpoint) || 0,
        fiftythACTCompositePercentileScore:
          parseInt(formValue.actComposite90) || 0,
        fiftythACTEnglishPercentileScore: parseInt(formValue.actEnglish90) || 0,
        midpointOfACTMathScore: parseInt(formValue.actMathMidpoint) || 0,
        percentageOfFirstTimeDegreeOrCertificateSeekingStudentsSubmittingSATScore:
          parseInt(formValue.percentSATSubmitting) || 0,
        percentageOfFirstTimeDegreeOrCertificateSeekingStudentsSubmittingACTScore:
          parseInt(formValue.percentACTSubmitting) || 0,
        secondarySchoolGPARequirement: formValue.secondarySchoolGPAMode,
        secondarySchoolRankRequirement: formValue.secondarySchoolRankMode,
        secondarySchoolRecordRequirement: formValue.secondarySchoolRecordMode,
        completionOfCollegePreparatoryProgramRequirement:
          formValue.collegePrepProgramMode,
        recommendations: formValue.recommendations,
        formalDemonstrationOfCompetenciesRequirement:
          formValue.formalDemonstrationCompetences,
        workExperienceRequirement: formValue.workExperienceRequired,
        personalStatementOrEssayRequirement: formValue.essayPersonalStatement,
        legacyStatusRequirement: formValue.legacyStatus,
        admissionTestScoresRequirements:
          formValue.admissionTestScoreRequirements,
        englishLanguageRequirement: formValue.englishLanguageRequirement,
        averageCostOfAttendance: parseInt(formValue.avgCostOfAttendance) || 0,
        averageTutionFees: parseInt(formValue.avgTuitionFees) || 0,
        estimatedBooksAndSupplies:
          parseInt(formValue.estimatedBooksSupplies) || 0,
        onCampusRoomAndBoard: parseInt(formValue.onCampusRoomBoard) || 0,
        onCampusOtherExpenses: parseInt(formValue.onCampusOtherExpenses) || 0,
        offCampusRoomAndBoard: parseInt(formValue.offCampusRoomBoard) || 0,
        offCampusOtherExpenses: parseInt(formValue.offCampusOtherExpenses) || 0,
        housingCapacity: parseInt(formValue.housingCapacity) || 0,
        combinedFoodAndHousingCharge:
          parseInt(formValue.combinedFoodHousingCharge) || 0,
        medianFamilyIncome: formValue.medianFamilyIncome || '',
        percentFirstTimeFullTimeUndergradsAwardedInstitutionalGrant:
          formValue.percentStudentsAwardedGrant || '',
        averageFirstTimeFullTimeUndergradsAwardedInstitutionalGrant:
          parseInt(formValue.avgGrantAmount) || 0,
        findScholarships: formValue.findScholarshipsLink
          ? [formValue.findScholarshipsLink]
          : [],
        fullTimeEnrollment: parseInt(formValue.fullTimeEnrollment) || 0,
        maleEnrollment: formValue.malePercentage || '',
        femaleEnrollment: formValue.femalePercentage || '',
        internationStudentsEnrollment: formValue.internationalStudents || '',
        fullTimeUndergraduateMaleEnrollment:
          formValue.fullTimeUndergraduateMaleEnrollment || '',
        fullTimeUndergraduateFemaleEnrollment:
          formValue.fullTimeUndergraduateFemaleEnrollment || '',
        fullTimeUnderGraduateIndianStudents:
          formValue.fullTimeUnderGraduateIndianStudents || '',
        white: formValue.whitePercentage || '',
        black: formValue.blackPercentage || '',
        hispanic: formValue.hispanicPercentage || '',
        asian: formValue.asianPercentage || '',
        americanIndianOrAlaskaNative: formValue.americanIndianPercentage || '',
        nativeHawaiianOrOtherPacificIslander:
          formValue.nativeHawaiianPercentage || '',
        twoOrMoreRaces: formValue.twoOrMoreRacesPercentage || '',
        raceOrEthnicityUnknown: formValue.raceUnknownPercentage || '',
        studentFacultyRatio: formValue.studentFacultyRatio || '',
        fullTimeUSNonResidentFacultyShare:
          formValue.fullTimeUSNonResidentFacultyShare || '',
        fullTimeFacultyProportion: formValue.fullTimeFacultyProportion || '',
        numberOfCoursesOffered: parseInt(formValue.numCoursesOffered) || 0,
        faculty: formValue.faculty || '',
        medianEarningsOfGraduatesWorkingPostOneYearCompletion:
          formValue.medianEarnings1Year || '',
        medianEarningsOfGraduatesWorkingPostFiveYearCompletion:
          formValue.medianEarnings5Years || '',
        percentEarningAboveHighSchool11Years:
          formValue.percentEarningAboveHighSchool11Years || '',
        totalCohortGraduationRate: formValue.graduationRate || '',
        internationalStudentsGraduationRate:
          formValue.internationalStudentsGraduationRate || '',
        acceptanceRate: formValue.acceptanceRate || '',
        foodAndOtherExpenses: formValue.foodAndOtherExpenses || '',
        others: formValue.additionalNotes || '',
        uk: formValue.uk || '',
        eu: formValue.eu || '',
        postGraduate: formValue.postGraduate || '',
        underGraduate: formValue.underGraduate || '',

        partTimeStudentEnrollment: formValue.partTimeEnrollment || '',
        totalEnrollmentInInstitution: formValue.totalEnrollment || '',
        totalDepartments: formValue.totalDepartments || '',
        popularEmployers: formValue.popularEmployers || '',
        // medicalApplicationsDeadline: formValue.medicalApplicationsDeadline ? new Date(formValue.medicalApplicationsDeadline).toISOString() : ''
        medicalApplicationsDeadline: this.toIsoStringSafe(
          formValue.medicalApplicationsDeadline,
        ),
      };

      const apiCall =
        this.undergraduateId > 0
          ? this.addInstituteService.updateUndergraduateDetails(request)
          : this.addInstituteService.undergraduatedetails(request);

      apiCall.subscribe({
        next: (res: any) => {
          const savedId = res.result?.Id || res.result?.id || res.id;
          if (savedId) {
            this.undergraduateId = savedId;
          }
          this.onSaveSuccess.emit({
            mode: this.undergraduateId > 0 ? 'edit' : 'add',
            response: res,
          });
        },
        error: (err: any) => {
          this.onSaveError.emit(err);
        },
      });
    } else {
      this.markFormGroupTouched(this.form);
      scrollToFirstInvalidControl();
      const invalidFields = this.getInvalidFields();
      this.onSaveError.emit({ validationError: true, fields: invalidFields });
    }
  }

  private getInvalidFields(): string[] {
    const invalid: string[] = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        // Convert camelCase to Space Case for better readability
        const label = name
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (str) => str.toUpperCase());
        invalid.push(label);
      }
    }
    return invalid;
  }

  private markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }
}
